<template>
  <div :class="`mb-3 w-full rounded-sm border px-3 py-3 txt-body-m-regular ${colorClasses}`" role="alert" data-testid="alert-box">
    <div class="inline-flex w-full items-start">
      <SvgIcon :path="path" :size="20" class="mt-1 mr-3" />
      <div class="flex w-full gap-2">
        <div class="flex-1">
          <h3 v-if="slots.header" class="txt-body-l-medium">
            <slot name="header"></slot>
          </h3>
          <div class="txt-body-s-regular">
            <slot />
          </div>
        </div>

        <div v-if="slots.actions" class="flex-none" data-testid="alert-box-actions">
          <slot name="actions"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default { name: 'AlertBox' }
</script>

<script setup lang="ts">
import { mdiInformation, mdiAlert, mdiCheckCircle, mdiAlphaXCircle } from '@mdi/js'
import { computed, useSlots } from 'vue'

const slots = useSlots()

const props = defineProps<{
  type: 'danger' | 'info' | 'success' | 'warning' | 'neutral'
  iconPath?: string
}>()

const iconPaths = {
  danger: mdiAlphaXCircle,
  info: mdiInformation,
  success: mdiCheckCircle,
  warning: mdiAlert,
  neutral: mdiInformation,
}

const colors = {
  danger: 'bg-error-subtle text-error',
  info: 'bg-button-secondary-color text-selected',
  success: 'bg-success-subtle text-success',
  warning: 'bg-secondary-subtlest text-warning',
  neutral: 'bg-surface-elevation-2 text-subtle',
}

const path = computed(() => props.iconPath || iconPaths[props.type])
const colorClasses = computed(() => colors[props.type])
</script>
